import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

import './main.css'
import './styles.css'
import React, { useState, useRef, useEffect, useCallback } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Header from './Header'
import { useLocation, useHistory } from "react-router-dom";
import { isEmpty } from "utils/array";
import { useSelector } from "react-redux";
import { isSuper, isAdmin } from 'utils/auth'
import removeParentByPermissions from 'utils/permissions'
// import 'react-pro-sidebar/dist/css/styles.css';
import { checkSection, checkChilds } from './utils'

import { SECTIONS, MODULE_LIST, USER_TESTER, MODULE_TESTER } from '../../modules'
import { Svg } from '../Svg'
import { getTheme } from './theme'
import { goToV4 } from '../../FrontV4';
import ModalIncidenteOptions from './ModalIncidenteOptions';
import { useSidebarStorage } from './sidebarStorage';
import { RiArrowRightSLine } from 'react-icons/ri';
import clsx from 'clsx';
import AzapfyIconeImg from 'assets/images/azapfy-icone.png'
import AzapfyNameImg from 'assets/images/azapfy-name.png'

function generateMenuId(module) {
	if (!module.title) return "";
	const menuId = module.title
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-z0-9\s]/g, "")
		.replace(/\s+/g, "-")
		.replace(/^-+|-+$/g, "");
	return menuId;
}

const Icon=({icon,patch})=>{
    return  patch ? Svg(patch) : <FontAwesomeIcon icon={icon} width={'15px'} />
}

function checkUser(auth){
    let grupo = auth.grupos[auth.grupo_ativo].user.grupo
    return USER_TESTER.includes(grupo)
}

function organize(authState){
    const SUPER = isSuper(authState);
    const ADMIN = isAdmin(authState);
    const MODULES = []
    let LIMIT_USER = false

    if(!authState.grupos || !authState.grupos[authState.grupo_ativo]) return []

    LIMIT_USER = checkUser(authState)

    MODULE_LIST.forEach(module => {
        if(module.enabled && module.menu){
            const habilited = removeParentByPermissions(authState,module.children,SUPER,ADMIN,module)

            if(habilited && module.id !=='dashboard') {
                let moduleCheck = checkChilds(module,authState,SUPER,ADMIN)      // VERIFICA PERMISSÕES DOS CHILDS
                let section = SECTIONS[moduleCheck.section || 'gerais']
                checkSection(MODULES,section,moduleCheck,true)                   // ADICIONA À LISTA DE MODULES, DIVIDIDA EM SEÇÕES
            }

            // MODULOS VISÍVEIS MAS NÃO ACESSÍVEIS
            else if ((!habilited && module.id !=='dashboard') && LIMIT_USER){
                let moduleCheck = {...module}
                const hasChildren = module.children && !isEmpty(module.children)
                let parent = MODULE_TESTER.includes(module.id)
                if(hasChildren) {
                    let childs = module.children.map(child=>{
                        if(MODULE_TESTER.includes(child.id)){
                            parent = true
                            return {...child,menu:false}
                        }
                        return null
                    }).filter(item=>item)
                    moduleCheck = {...module,children:childs}
                }

                if(parent){
                    let section = SECTIONS[moduleCheck.section || 'gerais']
                    checkSection(MODULES,section,moduleCheck,false)
                }
            }
        }
    })
    //console.log("CALC")
    return MODULES
}

const CheckRoute=()=>{

    const location = useLocation()
    const history = useHistory()

    const authState = useSelector((state) => state.auth);

    const [modulesState,setModulesState] = useState([])

    const [disable,setDisable] = useState(false)

    //console.log("MODULES")

    useEffect(()=>{
        if(location.pathname.slice(0,4) === '/app'&&authState.grupos[authState.grupo_ativo]){
            setModulesState(organize(authState))
        }
    },[authState])

    useEffect(()=>{
        if(location.pathname.slice(0,4) !== '/app'){
            !disable && setDisable(true)
        }else disable && setDisable(false)
    },[location.pathname])

    const goRoute=useCallback(async (module)=>{
        if(!goToV4(module, authState)) return
        let dest = "/app"+module
        if(dest === document.location.hash.replace('#','')) return
        history.push("/app"+module)
    },[authState])

    return disable?<></>:<SidebarMemo auth={authState} goRoute={goRoute} sections={modulesState}/>

}

let Sidebar=({goRoute,sections,auth})=>{

    const ref = useRef(null)
    const refModalIncidente = useRef(null)
    const refHeader = useRef(null)

    let previousTarget = useRef(null)
    let previousMenu = useRef(null)

    const { pathname } = useLocation();

    const sidebarState = useSidebarStorage();

    const isActive = (route) => {
        if (!route) return false;
        return pathname.includes(route);
    }

    const isSubMenuExpanded = (module) => {
        return sidebarState.expandedItemIds.includes(generateMenuId(module));
    }

    const toggleSubMenuExpanded = (module) => {
        sidebarState.toggleExpanded(generateMenuId(module));
    }


    useEffect(() => {
        if (ref.current && typeof sidebarState.scrollPosition === "number") {
            const scrollComponent = ref.current.getElementsByClassName('pro-menu')[0];
            if (scrollComponent) {
                scrollComponent.scrollTop = sidebarState.scrollPosition;
            }
        }
    }, [sidebarState.scrollPosition]);

    //console.log("RENDERIZOU")

    function ajustToltip(e){
        let titles = ref.current.getElementsByClassName('toltip-inner-item solo-item')
        titles = Array.from(titles)
        titles.forEach(el => {
            el.style.transform = `translate(12px, ${-22 - e.target.scrollTop}px)`
        });
    }

    useEffect(()=>{
        if(ref.current){
            try{
                let target = decodeURI(document.location.hash.replace('#/app',''))
                if(target === '/dashboard') {
                    refHeader.current.setMark()
                    return
                }
            }
            catch{}
        }
    },[ref.current])

    useEffect(()=>{
        try{
            let scrollComponent = ref.current.getElementsByClassName('pro-menu')[0]
            scrollComponent.onscroll = ajustToltip
        }
        catch{}
    },[ref.current])

    function route(module,menu,e){
        if(menu===false) {
            e.stopPropagation()
            e.preventDefault()
            return
        }

        if(module === '/AberturaDeIncidentes'){
            refModalIncidente.current.open()
            return
        }else{
            goRoute(module)
        }
    }

    function closeSide(e){
        if (!e.currentTarget.contains(e.relatedTarget) && !sidebarState.isCollapsed) {
            sidebarState.setCollapsed(true)
        }
    }

    function handleToggleSidebar(){
        sidebarState.setCollapsed(!sidebarState.isCollapsed)
        // refHeader.current.blur()
    }

    return (
        <>
            <ModalIncidenteOptions ref={refModalIncidente} />
            <div className="margin-sidebar" />
            <div className="root-side-scroll" onBlur={closeSide} tabIndex={-1}>
                <div className={"root-siderbar dark-sidebar"} ref={ref} >
                    <ProSidebar collapsed={sidebarState.isCollapsed} collapsedWidth={'60px'} width={'250px'}>
                        <div className="collapse-header-button" onClick={handleToggleSidebar}>
                            <RiArrowRightSLine size={'20px'}/>
                        </div>
                        <div
                            className={clsx("d-flex align-items-center", !sidebarState.isCollapsed && "justify-content-center")}
                            style={{ marginBottom: "1.5rem" ,gap: "1rem", padding: "23px 9px 0px" }}
                        >
                            <img
                                alt="Logo Azapfy"
                                src={AzapfyIconeImg}
                                aria-expanded={!sidebarState.isCollapsed}
                                className={"logo_azapfy"}
                                width={38}
                                height={26}
                            />
                            {!sidebarState.isCollapsed && (
                                <img
                                    alt="Azapfy"
                                    src={AzapfyNameImg}
                                    aria-expanded={!sidebarState.isCollapsed}
                                    className={"name_azapfy"}
                                    height={34}
                                />
                            )}
				        </div>
                        <Header
                            ref={refHeader}
                            route={route}
                            setCollapse={sidebarState.setCollapsed}
                            collapse={sidebarState.isCollapsed}
                            previousTarget={previousTarget}
                            previousMenu={previousMenu}
                        />
                        <Menu iconShape="square">
                            {sections.map((section,index) => {
                                return (
                                    [-1,...section.modules].map((module,key)=>{

                                        if (module === -1) {
                                            return (
                                                <>
                                                    {index ? <div className='section-sidebar-pro'>{section.nome}</div> : null}
                                                </>
                                            )
                                        }

                                        if (Array.isArray(module.children)) {
                                            const isExpanded = isSubMenuExpanded(module);

                                            return (
                                                <SubMenu
                                                    key={`menuside-${key}`}
                                                    title={module.title}
                                                    icon={<Icon patch={module.patch} icon={module.icon} />}
                                                    className={isActive(module.route) ? "inner-item-focus" : ""}
                                                    open={isExpanded}
                                                    onOpenChange={(open) => {
                                                        if (open !== isExpanded) {
                                                            toggleSubMenuExpanded(module);
                                                        }
                                                    }}
                                                >
                                                    <div className='toltip-inner-item'>{module.title}</div>
                                                    {module.children.map((child,i) => {
                                                        if (!child.menu) return null
                                                        return (
                                                            <MenuItem
                                                                onClick={(e) => route(module.route+child.route,child.menu,e)}
                                                                id={(!module.menu) && 'disable-pro-menu'}
                                                                key={`menuside-${key}-${i}`}
                                                                route={module.route+child.route}
                                                                icon={<Icon patch={child.patch} icon={child.icon}/>}
                                                                className={isActive(module.route + child.route) ? "inner-item-focus" : ""}
                                                            >
                                                                {child.title}
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </SubMenu>
                                            )
                                        }

                                        return (
                                            <MenuItem
                                                onClick={(e) => route(module.route,module.menu,e)}
                                                route={module.route}
                                                id={(!module.menu) && 'disable-pro-menu'}
                                                key={`menuside-${key}`}
                                                icon={<Icon patch={module.patch} icon={module.icon}/>}
                                                className={isActive(module.route) ? "inner-item-focus" : ""}
                                            >
                                                {module.title}
                                                <div className='toltip-inner-item solo-item'>{module.title}</div>
                                            </MenuItem>
                                        )
                                    })
                                )
                            })}
                        </Menu>
                    </ProSidebar>
                </div>
            </div>
        </>
    )
}
let SidebarMemo = React.memo(Sidebar)
export default React.memo(CheckRoute)
